/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntervalMovement
 */
export interface IntervalMovement {
    /**
     * 
     * @type {string}
     * @memberof IntervalMovement
     */
    startingFrom: string;
    /**
     * 
     * @type {string}
     * @memberof IntervalMovement
     */
    endingAt: string;
    /**
     * Portion (0-1) of interval within opening hours
     * @type {number}
     * @memberof IntervalMovement
     */
    openedPortion: number;
    /**
     * 
     * @type {number}
     * @memberof IntervalMovement
     */
    numberOfIncoming?: number;
    /**
     * 
     * @type {number}
     * @memberof IntervalMovement
     */
    numberOfOutgoing?: number;
}

export function IntervalMovementFromJSON(json: any): IntervalMovement {
    return IntervalMovementFromJSONTyped(json, false);
}

export function IntervalMovementFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntervalMovement {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startingFrom': json['starting_from'],
        'endingAt': json['ending_at'],
        'openedPortion': json['opened_portion'],
        'numberOfIncoming': !exists(json, 'number_of_incoming') ? undefined : json['number_of_incoming'],
        'numberOfOutgoing': !exists(json, 'number_of_outgoing') ? undefined : json['number_of_outgoing'],
    };
}

export function IntervalMovementToJSON(value?: IntervalMovement | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'starting_from': value.startingFrom,
        'ending_at': value.endingAt,
        'opened_portion': value.openedPortion,
        'number_of_incoming': value.numberOfIncoming,
        'number_of_outgoing': value.numberOfOutgoing,
    };
}

